module.exports = __webpack_public_path__ + "static/media/firebase.5cec627c.svg";